module.exports = __webpack_public_path__ + "static/chaos-game-20c4833eb95ad08554ab0b5617f6907d.gif";